<svg-icon title="{{tooltipText}}" src="{{iconTypeMap[iconButtonType].src}}" [svgClass]="iconTypeMap[iconButtonType].svgClass"></svg-icon>